import { StateType } from 'data/types'

export const getPayment = (state: StateType, id: string) => state.payments.payment[id]?.data

export const getPaymentError = (state: StateType, id: string) => state.payments.payment[id]?.error
